<div class="paymenthistory_page">
    <div class="search-container">
        <mat-form-field class="questionary_form_fields" appearance="outline">
            <mat-label style="font-family: var(--font);">Search Payment Details</mat-label>
            <input matInput type="text" style="font-family: var(--font);" placeholder="Search Payment Details" />
            <mat-icon matSuffix style="color: black;">search</mat-icon>
        </mat-form-field>
    </div>
    <div class="table-container">
        <table class="payment-history-table">
            <thead>
                <tr>
                    <th>Transaction ID</th>
                    <th>Payment Date</th>
                    <th>PlanDuration</th>
                    <th>Payment Status</th>
                    <th>Plan Name</th>
                </tr>
            </thead>
            <tbody>

                <!-- <img src="assets\no_transaction.png" class="transaction_image">
                <div style="margin: 10px;font-size: 25px;font-family: var(--font);">No Transactions Yet</div>
                <div style="font-size: 13px;font-family: var(--font);padding-bottom: 20px;">Once you start using
                    Google Pay, you can keep track of all your
                    purchases and other activity here
                </div> -->
                <tr *ngFor="let transaction of transactions" >
                    <td *ngIf="transaction.BusinessInfoId == presentbusinessid" >{{ transaction.Transaction_Id}}</td>
                    <td *ngIf="transaction.BusinessInfoId == presentbusinessid" >{{ transaction.CreatedOn }}</td>
                    <td *ngIf="transaction.BusinessInfoId == presentbusinessid" >{{ transaction.PlanDuration || 'N/A' }}</td>
                    <td *ngIf="transaction.BusinessInfoId == presentbusinessid" >{{ transaction.Status || 'N/A' }}</td>
                    <td *ngIf="transaction.BusinessInfoId == presentbusinessid" >{{ transaction.PlanName }}</td>
                </tr>
                <tr *ngIf="transactions?.length == null">
                    <td colspan="5" class="no-history">
                        <img src="assets/no_transaction.png" style="margin: 10px 0px; width:250px; height: 250px;"
                            class="transaction_image">
                        <div style="margin: 10px; font-size: 25px; font-family: var(--font);">No Transactions Yet</div>
                        <div style="font-size: 13px; font-family: var(--font); padding-bottom: 20px;">
                            Once you start using the service, you can keep track of all your purchases and other
                            activity here.
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>